import React, { useRef } from 'react'

import { omit, pick } from 'ramda'
import ReactDatepicker from 'react-datepicker'

import { DatepickerProps } from '@customTypes'
import { LabelGuard, FloatingLabelGuard } from '@customTypes/components/_helpers'
import { Input } from '_components/input'

import { InnerInputProps } from './helpers/types'

type Guards = LabelGuard & FloatingLabelGuard

export const Datepicker: React.FC<DatepickerProps & Guards> = props => {
  const datepicker = useRef<ReactDatepicker>(null)

  const inputProps = pick(
    [
      'id',
      'label',
      'renderLabel',
      'hasError',
      'helpText',
      'isClearable',
      'iconPlacement',
      'float',
      'buttonStyle',
      'icon',
    ],
    props
  ) as InnerInputProps

  const datepickerProps = omit(
    ['isClearable'],
    props
  )

  return (
    <ReactDatepicker
      {...datepickerProps}
      ref={datepicker}
      customInput={
        <Input
          {...inputProps}
          icon="calendar"
          pattern="d{1,2}/\d{1,2}/\d{4}"
          iconSize="1.5em"
          buttonStyle
        />
      }
    />
  )
}

Datepicker.defaultProps = {
  popperPlacement: 'bottom-end',
  placeholderText: 'MM/DD/YYYY',
  showPopperArrow: false,
}
